import React, { Component } from 'react';
import PropTypes from 'prop-types';
import defaultUserPhoto from '../../../../images/default_user.png';

export default class WorkersPreviewPhotosList extends Component {
  static propTypes = {
    selectedWorkers: PropTypes.array.isRequired,
    shownPhotosQuantity: PropTypes.number
  };

  render () {
    const { selectedWorkers, shownPhotosQuantity } = this.props;
    const hiddenPhotosQuantity = shownPhotosQuantity ? selectedWorkers.length - shownPhotosQuantity : 0;
    return (
      <div className='workers-preview-list-wrapper'>
        { selectedWorkers.map((worker, i) => {
          if (shownPhotosQuantity && i >= shownPhotosQuantity) {
            return null;
          }
          return (
            <div
              key={worker.id}
              className='worker-photo'
              style={{ backgroundImage: `url('${worker.photo_image_url || defaultUserPhoto}')` }}
            />
          );
        })}
        { shownPhotosQuantity && hiddenPhotosQuantity > 0 && (
          <div className='hided-photos-quantity'>+ {hiddenPhotosQuantity}</div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/jobDetails/TipsAndRates/WorkersPreviewPhotosList.js